import { render, staticRenderFns } from "./CheckBoxConfig.vue?vue&type=template&id=2ced7ce0&scoped=true"
import script from "./CheckBoxConfig.vue?vue&type=script&lang=js"
export * from "./CheckBoxConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ced7ce0",
  null
  
)

export default component.exports